import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import { MuiThemeProvider } from "@material-ui/core/styles";
import Labels from "../../../../../lang/Labels_en";
import Divider from "@material-ui/core/Divider";
import { useStyles, transferList } from "./GeneralInformationStyle";
import Typography from "@material-ui/core/Typography";
import { useState } from "react";
import TransferListService, {
  KeywordsType,
  TransferListServiceType,
} from "../../../../../service/transfer-list/TransferListService";
import { useAppContext } from "context/AuthContext";
import MessageType from "utils/MessageType";

export default function TransferList({ fieldName, values, setFieldValue }: any) {
  const { not, intersection, handleToggle, left, setLeft }: TransferListServiceType = TransferListService();
  const classes = useStyles();
  const { showMessage } = useAppContext();
  const [checked, setChecked] = useState<KeywordsType[]>([]);
  const [right, setRight] = useState<KeywordsType[]>(values);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleCheckedRight = () => {
    if (right?.length + checked?.length > 5) {
      showMessage("Max 5 keywords allowed.", MessageType.ERROR);
    } else {
      setRight(right.concat(leftChecked));
      setFieldValue(fieldName, right.concat(leftChecked));
      setLeft(not(left, leftChecked));
      setChecked(not(checked, leftChecked));
    }
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setFieldValue(fieldName, not(right, rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const customList = (title: string, items: any) => (
    <Grid className={classes.transferListContainer}>
      <Typography className={classes.cardHeader}>{title}</Typography>
      <Divider />
      <List dense component="div" role="list">
        {items.map((value: any, i: number) => {
          const labelId = `transfer-list-item-${value.id}-label`;
          return (
            <ListItem key={i} role="listitem" button onClick={handleToggle(checked, setChecked, value)}>
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  color="primary"
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value.keyword} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Grid>
  );

  return (
    <MuiThemeProvider theme={transferList}>
      <Grid container alignItems="center">
        <Grid item className={classes.transferListBox}>
          {customList(Labels.KEYWORDS, left)}
        </Grid>
        <Grid item className={classes.transferListMiddle}>
          <Grid container direction="column" alignItems="center">
            <Button
              variant="outlined"
              size="small"
              className={classes.buttonPanel}
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              {Labels.ADD}
            </Button>
            <Button
              variant="outlined"
              size="small"
              className={classes.buttonPanel}
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              {Labels.REMOVE}
            </Button>
          </Grid>
        </Grid>
        <Grid item className={classes.transferListBox}>
          {customList(Labels.SELECTED_KEYWORDS, right)}
        </Grid>
      </Grid>
    </MuiThemeProvider>
  );
}
